export function yearList(){
    let startYear = 1990;
    let currentYear = (new Date()).getFullYear()
    let years = []
    for (var i = currentYear; i >= startYear; i--){
        years.push(i)
    }
    return years;
}